<template>
  <button
    class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full p-2 hover:bg-black/20 active:bg-black/25"
    :disabled="notificationPermission === 'denied'"
    @click="onClick"
    title="Vil du ha push-varsler fra UL? Trykk her!"
  >
    <Icon :icon="iconName" class="h-6 w-6 text-black" />
  </button>
</template>

<script setup lang="ts">
import type { MessagePayload } from 'firebase/messaging'
import { computed, onMounted } from 'vue'
import { useFirebaseServiceWorker } from '../lib/useFirebaseServiceWorker'
import Icon from './Icon.vue'

const { notificationPermission, registerFirebaseMessaging, isIosAndNeedsPWA } = useFirebaseServiceWorker()
const iconName = computed(() => {
  switch (notificationPermission.value) {
    case 'denied':
      return 'bellOff'
    case 'granted':
      return 'bellCheck'
    default:
      return 'bell'
  }
})

function onMessage(message: MessagePayload) {
  // If the message doesn't have a notification, return
  // This is the case when the message is sent in the background
  const { title, body } = message.data ?? message.notification ?? {}
  if (!title || !body) return
  window.alert(`${title} - ${body}`)
}

function onClick() {
  if (isIosAndNeedsPWA) {
    return window.alert(
      "For å aktivere push-varsler på iOS, må du installere UL26 som en PWA. Trykk på delingsknappen i nettleseren og velg 'Legg til på Hjem-skjerm'."
    )
  }

  if (notificationPermission.value === 'default') {
    registerFirebaseMessaging(onMessage)
  }
  if (notificationPermission.value === 'granted') {
    window.alert('Du har allerede aktivert push-varsler fra UL! Du vil motta varsler når det skjer noe spennende.')
  }
  if (notificationPermission.value === 'denied') {
    window.alert(
      'Du har tidligere avslått push-varsler fra UL, og da får vi ikke lov til å spørre igjen før du fjerner avslaget. Du kan aktivere dem igjen i nettleserens innstillinger.'
    )
  }
}

onMounted(() => {
  if (notificationPermission.value === 'granted') {
    registerFirebaseMessaging(onMessage)
  }
})
</script>

<style></style>
